import * as React from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    Redirect
} from "react-router-dom";
import Login from "./pages/login/login";
import Sites from "./pages/projects";
import Register from "./pages/register";
import Site from "./pages/projects/project";
import Equipment from "./pages/equipment";
import Users from "./pages/users";
import User from "./pages/users/user";
import NewProject from "./pages/projects/newProject/newProject";
import { connect } from "react-redux";
import { State } from "./interfaces/State";
import {logout} from "./redux/user/action";
import Invitation from "./pages/invitation";
import SideBar from "./components/SideBar/Sidebar";
import Header from "./components/header";
import Settings from "./pages/settings";
import Reports from "./pages/reports";
import Alerts from "./pages/notifications";
import Contractors from "./pages/contractors";

interface IProps {
    loggedIn: boolean;
    logout: () => void;
    name: string;
}

class App extends React.Component<IProps> {

    logout(){
        this.props.logout();
        return true;
    }

    openMenu(){
        if (document.querySelector(".side-bar")){
            const element : any = document.querySelector(".side-bar");
            element.className =  element.className.includes("d-none") ? "side-bar d-sm-block" : "side-bar d-none d-sm-block";
        }
    }

    render(){
        return (
            <Router basename="/">
                <Header loggedIn={this.props.loggedIn} logout={() => this.logout()} name={this.props.name} />                
                <div className="page">
                    {this.props.loggedIn ? <SideBar /> : null}
                    <div className="main-page">
                        <Switch>
                            <Route exact={true} path="/" render={() => (this.props.loggedIn ? <Redirect to="/projects" /> : <Redirect to="/login" />)} />
                            <Route exact={true} path="/login" render={() => (this.props.loggedIn ? <Redirect to="/projects" /> : <Login />)} />
                            <Route path="/register">
                                <Register />
                            </Route>
                            <Route exact={true} path="/projects" render={() => (this.props.loggedIn ? <Sites /> : <Redirect to="/login" />)} />
                            <Route exact={true} path="/projects/new" render={() => (this.props.loggedIn ? <NewProject /> : <Redirect to="/login" />)} />
                            <Route exact={true} path="/projects/:projectId" render={() => (this.props.loggedIn ? <Site /> : <Redirect to="/login" />)} />
                            <Route exact={true} path="/projects/:projectId/equipment" render={() => (this.props.loggedIn ? <Equipment /> : <Redirect to="/login" />)} />
                            <Route exact={true} path="/contractors" render={() => (this.props.loggedIn ? <Contractors /> : <Redirect to="/login" />)} />
                            <Route exact={true} path="/equipment" render={() => (this.props.loggedIn ? <Equipment /> : <Redirect to="/login" />)} />
                            <Route exact={true} path="/people" render={() => (this.props.loggedIn ? <Users /> : <Redirect to="/login" />)} />
                            <Route exact={true} path="/people/:id" render={() => (this.props.loggedIn ? <User /> : <Redirect to="/login" />)} />
                            <Route exact={true} path="/reports" render={() => (this.props.loggedIn ? <Reports /> : <Redirect to="/login" />)} />
                            <Route exact={true} path="/alerts" render={() => (this.props.loggedIn ? <Alerts /> : <Redirect to="/login" />)} />
                            <Route exact={true} path="/settings" render={() => (this.props.loggedIn ? <Settings /> : <Redirect to="/login" />)} />
                            <Route path="/invitation/:code">
                                <Invitation />
                            </Route>
                            <Redirect to="/projects" />
                        </Switch>
                    </div>
                </div>                
            </Router>
        )
    }

}


export default connect((state : State) => ({
    loggedIn: !!state.app.token,
    name: state.user.name
}), ({
    logout
}))(App);